import ImsObjectCollection from 'app/shared/collections/ims_object_collection.service';
import * as _ from 'lodash';

// Need to flesh out a detailed error object.
export interface IMSError extends Error {
    data: {
        detail?: string;
        [x: string]: string | number | Array<string>;
    };
    status: number;
}

const hasLicensingError = (error: IMSError): boolean => {
    const err = error.data.error;

    if (err === 'limit_reached' || err === 'license_expired') {
        return true;
    }
    return false;
};

// Turn status codes into something human
const HTTP_STATUS_ERRORS = {
    500: 'Unknown server error', // Server error
    405: 'Bad request', // Method not allowed
    404: 'Not found', // Not found
    403: 'You do not have permission', // Forbidden
    401: 'You do not have permission', // Unauthorized
    400: 'Bad request', // Bad request
};
HTTP_STATUS_ERRORS[-1] = 'Unable to connect to server'; // No response from server

export const errorToText = (
    error: IMSError,
    collection: ImsObjectCollection = undefined,
): string => {
    let errorMessage = ''; //REVIEW If we don't have error text to print should we set a default?
    if (error) {
        console.log(error, error.status);
        if (error.data || error.status) {
            if (error.status === 403 && error.data && hasLicensingError(error)) {
                // some super specific error type handling here.
                // for the limit reached type errors, we trust the message is delivered as well.
                errorMessage += '<br > - ' + error.data.msg;
            } else if (error.status === 403 || error.status === 401) {
                // Handle permissions-related errors here
                errorMessage += '<br > - ' + HTTP_STATUS_ERRORS[error.status];
            } else {
                //Handle all other errors here
                if (error.data && typeof error.data === 'object') {
                    for (const errorItemName in error.data) {
                        const errorItem = error.data[errorItemName];
                        if (Array.isArray(errorItem)) {
                            for (let i = 0; i < errorItem.length; i++) {
                                let messageRow = errorItem[i];
                                const fieldName = _.capitalize(errorItemName);
                                if (messageRow === 'This field may not be blank.') {
                                    messageRow = fieldName + ' may not be blank.';
                                }
                                if (
                                    messageRow ===
                                    'Incorrect type. Expected pk value, received unicode.'
                                ) {
                                    messageRow = 'No value selected for ' + fieldName;
                                }
                                if (messageRow === 'This field is required.') {
                                    messageRow = fieldName + ' is required.';
                                }
                                if (errorItemName === 'conflicting_asset_id') {
                                    // it's possible we don't have the asset in the collection locally.
                                    // however clicking on the toast should pull it from the API if that's the case
                                    const asset = collection ? collection.get(messageRow) : null;
                                    const assetName = asset ? asset.name || '' : '';
                                    messageRow = `<b>Click to open conflicting Asset ${assetName}</b>`;
                                }
                                if (errorItemName === 'conflicting_ip_device_id') {
                                    // it's possible we don't have the IP device in the collection locally.
                                    // however clicking on the toast should pull it from the API if that's the case
                                    const ipDevice = collection ? collection.get(messageRow) : null;
                                    const ipDeviceName = ipDevice ? ipDevice.name || '' : '';
                                    messageRow = `<b>Click to open conflicting IP Device ${ipDeviceName}</b>`;
                                }
                                if (messageRow === 'Duplicate of existing template_name') {
                                    messageRow =
                                        'An asset template with the same template name already exists.';
                                }
                                if (errorItemName === 'conflicting_asset_template_id') {
                                    messageRow = null; //To prevent displaying second error message with just the template id
                                }

                                if (messageRow) {
                                    errorMessage += '<br > - ' + messageRow;
                                }
                            }
                        } else if (_.isString(errorItem)) {
                            // If it is a string, do not iterate over the characters in the string
                            errorMessage += '<br > - ' + errorItem;
                        }
                    }
                }
            }
        } else if (error.message) {
            errorMessage += '<br > - ' + error.message;
        }
    }
    return errorMessage;
};
